import script from "./ProfileStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileStep.vue?vue&type=script&setup=true&lang=js"

import "./ProfileStep.vue?vue&type=style&index=0&id=76f27cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f27cc2"]])

export default __exports__